<template>
  <div id="app">
    <keep-alive max="10" :exclude="/player|avplayer/">
      <router-view class="main-view" :key="$route.fullPath"></router-view>
    </keep-alive>
    <keep-alive max="10" :exclude="/player|avplayer/">
      <router-view
        name="leftSide"
        class="left-side"
        :key="$route.fullPath"
      ></router-view>
    </keep-alive>
    <div
      v-if="!mouseActivated"
      class="mouse-check"
      @mouseover="mouseOver"
    ></div>
    <!-- <transition name="fade"> -->
    <spinner :loading="loading" v-show="loading"></spinner>
    <notification />
    <LiveStatusNotice :status="liveStatusValue" v-show="liveStatusVisible" />
    <!-- </transition> -->
  </div>
</template>

<script>
import Spinner from "./components/spinner.vue";
import Notification from "./components/notification.vue";
import LiveStatusNotice from "./components/LiveStatusNotice.vue";
import { contentsPermissionCheck } from "@/utils/common";
import * as websocket from "@/api/ws.js";
import { getOsType } from "@/api/smartTv.js";

export default {
  data() {
    return {
      isLongPressEvent: false,
      loading: false,
      loadingTimer: null,
      loadingDealy: 1500,
      liveStatusVisible: false,
      liveStatusValue: 1,
    };
  },

  computed: {
    fousedView() {
      return this.$store.getters.focusedView;
    },
    mouseActivated() {
      return this.$store.getters.mouseActivated;
    },
    lambdaInfo() {
      return this.$store.getters.lambdaInfo;
    },
    userInfo() {
      return this.$store.getters.userInfo;
    },
  },

  components: {
    Spinner,
    Notification,
    LiveStatusNotice,
  },

  methods: {
    mouseOver() {
      this.$store.commit("SET_INPUT_DEVICE", "mouse");
    },
    onProgress() {
      this.loading = true;
    },
    offProgress() {
      this.loading = false;
    },
    liveStatusCheck(status) {
      if (status === 0 || status === 2) this.liveStatusVisible = true;
      else this.liveStatusVisible = false;
      this.liveStatusValue = status;
    },
    offLiveStatus() {
      this.liveStatusVisible = false;
    },
    async lgDeepLinkCheck() {
      // deepLink를 통해 앱이 재실행 되는 경우 해당 영상으로 이동
      let launchParams =
        window.PalmSystem && window.PalmSystem.launchParams
          ? window.PalmSystem.launchParams
          : "";

      if (launchParams) {
        let params = JSON.parse(launchParams);

        if (params.contentTarget) {
          // 로그인 유무 체크
          await this.$store
            .dispatch("DEEP_LINK_CHECK_SESSION")
            .then(async () => {
              let [type, id] = params.contentTarget.split("_");

              if (this.$route.path === "/player") {
                // 영상 시청 중 Deep Link가 들어오는 경우
                sessionStorage.setItem("deepLink", params.contentTarget);

                this.$router.replace({
                  name: "notice",
                  params: {
                    t: new Date().getTime(),
                  },
                });
              } else {
                if (type === "live") {
                  const checkParams = {
                    type: type,
                    id: id,
                    deepLinkCheck: true,
                  };

                  // 리그 전용 이용권 시청 권한 확인
                  contentsPermissionCheck(checkParams);
                }

                this.$router
                  .push({
                    name: "player",
                    params: {
                      vodId: id,
                      contentType: type,
                    },
                  })
                  .catch(() => {});
              }
            })
            .catch((err) => {
              console.log(err);

              let deepLinkValue = params.contentTarget;
              sessionStorage.setItem("deepLink", deepLinkValue);

              this.$store.commit("SET_USER_INFO", {});

              // login 페이지가 아닐 경우 로그인 페이지로 이동
              if (!window.location.hash.includes("/login/")) {
                this.$router.replace({
                  name: "login",
                  params: {
                    t: new Date().getTime(),
                  },
                });
                return;
              }
            });
        }
      }
    },
    onVisibilityChange() {
      if (document.hidden) {
        // 소켓 연결 해제
        websocket.disconnectWs();
      } else {
        // 소켓 재연결
        if (this.lambdaInfo?.w_login && this.userInfo?.userId) {
          websocket.connectWs(this.lambdaInfo.w_login, this.userInfo.userId);
        } else {
          console.log("socket 연결 시 사용자 정보 없음");
        }
      }
    },
  },
  created() {
    const self = this;

    this.$store.commit("SET_INPUT_DEVICE", "key");

    //add event into loading progress bar
    this.$progress.$on("on:progress", this.onProgress);
    this.$progress.$on("off:progress", this.offProgress);
    this.$progress.$on("liveCheck", this.liveStatusCheck);
    this.$progress.$on("offLiveStatus", this.offLiveStatus);

    if (process.env.VUE_APP_OS_TYPE == "samsung") {
      let i,
        keyCode = {},
        supportedKeys;
      supportedKeys = tizen.tvinputdevice.getSupportedKeys();
      for (i = 0; i < supportedKeys.length; i++) {
        keyCode[supportedKeys[i].name] = supportedKeys[i].code;
      }
      if (keyCode.hasOwnProperty("MediaPlayPause")) {
        tizen.tvinputdevice.registerKey("MediaPlayPause");
      }
    }

    document.addEventListener("keydown", function(e) {
      e.preventDefault();
      e.stopPropagation();

      // console.log("[ keyEvent ] : ", e);

      let keyInput = {
        focusView: self.fousedView,
        longPress: this.isLongPressEvent,
      };

      switch (e.keyCode) {
        case 37:
          keyInput.key = "ArrowLeft";
          break;
        case 38:
          keyInput.key = "ArrowUp";
          break;
        case 39:
          keyInput.key = "ArrowRight";
          break;
        case 40:
          keyInput.key = "ArrowDown";
          break;
        case 13:
          if (this.isLongPressEvent) {
            return;
          }
          keyInput.key = "Enter";
          break;
        case 461: // LG
        case 10009: // Samsung
          if (this.isLongPressEvent) {
            return;
          }
          keyInput.key = "Backspace";
          break;
        case 10182:
          // Samsung
          keyInput.key = "Exit";
          break;
        case 10252:
          keyInput.key = "MediaPlayPause";
          break;
        case 415:
          if (process.env.VUE_APP_OS_TYPE == "samsung") {
            keyInput.key = "MediaPlay";
          }
          break;
        case 19:
          if (process.env.VUE_APP_OS_TYPE == "samsung") {
            keyInput.key = "MediaPause";
          }
          break;
        case 413:
          if (process.env.VUE_APP_OS_TYPE == "samsung") {
            keyInput.key = "MediaStop";
          }
          break;
        case 10232:
          if (process.env.VUE_APP_OS_TYPE == "samsung") {
            keyInput.key = "MediaTrackPrevious";
          }
          break;
        case 10233:
          if (process.env.VUE_APP_OS_TYPE == "samsung") {
            keyInput.key = "MediaTrackNext";
          }
          break;
      }

      // 로딩 중 키 블록 처리
      if (
        this.loading &&
        keyInput.key !== "Backspace" &&
        keyInput.key !== "Exit"
      ) {
        return;
      }
      self.$store.commit("SET_INPUT_DEVICE", "key");
      self.$store.commit("SET_KEY_INPUT", keyInput);
      this.isLongPressEvent = true;
    });

    document.addEventListener("keyup", function(e) {
      this.isLongPressEvent = false;

      e.preventDefault();
      e.stopPropagation();
    });
  },
  mounted() {
    if (getOsType() === "lg") {
      document.addEventListener("webOSRelaunch", this.lgDeepLinkCheck);
    }

    document.addEventListener("visibilitychange", this.onVisibilityChange);
  },
  beforeDestroy() {
    if (getOsType() === "lg") {
      document.removeEventListener("webOSRelaunch", this.lgDeepLinkCheck);
    }

    document.removeEventListener("visibilitychange", this.onVisibilityChange);

    this.$progress.$off("on:progress", this.onProgress);
    this.$progress.$off("off:progress", this.offProgress);
    this.$progress.$off("liveCheck", this.liveStatusCheck);
    this.$progress.$off("offLiveStatus", this.offLiveStatus);
    this.offProgress();
    this.offLiveStatus();
  },
};
</script>

<style>
* {
  position: relative;
  margin: 0;
  padding: 0;
}
body {
  margin: 0;
  overflow: hidden;
  width: 100%;
  height: 108%;
}
p,
div {
  text-overflow: ellipsis;
}
.singleline {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.doubleline {
  overflow: hidden;
  white-space: normal;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

textarea:focus {
  outline: none;
}
button:focus {
  outline: none;
}
div:focus {
  outline: none;
}
/* img:focus {
  outline: none;
} */
input:focus {
  outline: none;
}

#app {
  font-family: NanumBarunGothic;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #a0a0a0;
  left: 0;
  top: 0;
  width: 1920px;
  height: 1080px;
  background-color: #141414;
  overflow: hidden;
}
.main-view {
  width: 1920px;
  height: 1080px;
}
.left-side {
  position: absolute;
  left: 0;
  top: 0;
}

.mouse-check {
  position: absolute;
  left: 0;
  top: 0;
  width: 1920px;
  height: 1080px;
  z-index: 10;
}

.fade-enter-active {
  transition: opacity 0.5s 1.5s;
}
.fade-leave-active {
  transition: opacity 0s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* 1280px 해상도 이하 */
@media all and (min-width: 0px) and (max-width: 1280px) {
  * {
    position: relative;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  body {
    margin: 0;
    overflow: hidden;
    width: 100%;
    height: 100%;
  }
  p,
  div {
    text-overflow: ellipsis;
  }
  .singleline {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  .doubleline {
    overflow: hidden;
    white-space: normal;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  textarea:focus {
    outline: none;
  }
  button:focus {
    outline: none;
  }
  div:focus {
    outline: none;
  }
  /* img:focus {
    outline: none;
  } */
  input:focus {
    outline: none;
  }

  #app {
    font-family: NanumBarunGothic;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: left;
    color: #a0a0a0;
    left: 0;
    top: 0;
    width: 1280px;
    height: 720px;
    background-color: #141414;
    overflow: hidden;
  }
  .main-view {
    width: 1280px;
    height: 720px;
  }

  .left-side {
    position: absolute;
    left: 0;
    top: 0;
  }

  .mouse-check {
    position: absolute;
    left: 0;
    top: 0;
    width: 1280px;
    height: 720px;
    z-index: 10;
  }

  .fade-enter-active {
    transition: opacity 0.5s 1.5s;
  }
  .fade-leave-active {
    transition: opacity 0s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
}
</style>
